import React, { createContext, useContext, useEffect, useState } from "react";
import Loading from "../components/Loading";
import { env } from "../utilities/function";
import axiosInstance from "../utils/axiosInstance";
import { useNavigate } from "react-router-dom";
import { clearCookie, setCookie } from "../utilities/cookies";
//import axios from 'axios';
//import { useMessage } from '../components/Header';
import { SocketProvider } from "./useSocket";
import { SocketProvider as SocketEmployeeProvider } from "./useEmployeeSocket";

const authorizeContext = createContext();

const AuthorizationProvider = ({ children }) => {
  const [content, setContent] = useState(
    <Loading message="Please wait, logging you in..." />
  );
  const [user, setUser] = useState({});
  const [currentOrganization, setCurrentOrganization] = useState(() => {
    const orgFromLocalStorage = localStorage.getItem("org");
    if (orgFromLocalStorage) {
      try {
        const parsedOrg = JSON.parse(orgFromLocalStorage);
        return parsedOrg;
      } catch (e) {
        // console.error("Authorize.js: Error parsing org from localStorage", e);
        return {};
      }
    }
    return {};
  });
  const navigate = useNavigate();
  // const { showError } = useMessage();

  const signOut = () => {
    clearCookie("accessToken");
    localStorage.removeItem("subscriptionId");
    localStorage.removeItem("org");
    localStorage.removeItem("user");
    const redirectTo =
      env("AUTHENTICATION_CLIENT") +
      "/logout?redirectto=" +
      encodeURIComponent(env("DOMAIN")) +
      "&&referrer=" +
      encodeURIComponent(env("DOMAIN"));

    setContent(
      <Loading
        message="Some thing went worng please try again some time later"
        redirectTo={redirectTo}
      />
    );
  };

  const authorize = async (loggedIn, cb) => {
    if (loggedIn) {
      setContent(children);
    } else {
      const redirectTo = "/signup";
      setContent(
        <Loading
          message="Please wait, redirecting you to Register Page..."
          redirectTo={redirectTo}
        />
      );
    }
    if (typeof cb === "function") cb(setUser);
  };

  const checkUserSubscription = async (userId) => {
    try {
      const response = await axiosInstance.post(`/user/subscription/check`, {
        userId: userId,
      });
      let data = response.data;
      if (data.success) {
        localStorage.setItem("subscriptionId", data.subscriptionId);
        await checkOrganization();
      } else {
        navigate("/createOrganization");
      }
    } catch (e) {
      navigate("/createOrganization");
    }
  };
  const getOrganizations = async () => {
    try {
      const response = await axiosInstance.get(`/api/organization`);
      let data = response.data;
      if (data.success) {
        if (data.data.length === 0) {
          const pendingInvitationToken = localStorage.getItem(
            "pendingInvitationToken"
          );
          if (!pendingInvitationToken) {
            navigate("/createOrganization");
          } else {
            await checkOrganization();
          }
        } else {
          await checkOrganization();
        }
      }
    } catch (e) {
      const pendingInvitationToken = localStorage.getItem(
        "pendingInvitationToken"
      );
      if (!pendingInvitationToken) {
        // navigate("/walkover"); // Or handle error differently
      }
    }
  };

  const checkOrganization = async () => {
    let selectedOrg = localStorage.getItem("org");
    if (selectedOrg) {
      try {
        selectedOrg = JSON.parse(selectedOrg);
        delete selectedOrg.logo;
        const response = await axiosInstance.post(`/api/organization/check`, {
          organizationId: selectedOrg._id,
          organization: selectedOrg,
        });
        let data = response.data;
        if (!data.success) {
          localStorage.removeItem("org");
          const pendingInvitationToken = localStorage.getItem(
            "pendingInvitationToken"
          );
          if (!pendingInvitationToken) {
            navigate("/listOrganization");
          }
        } else {
          setCookie("orgToken", data.data);
          setCurrentOrganization(selectedOrg);
        }
      } catch (e) {
        // console.error("[Authorize.js/checkOrganization] Error during API check for stored org:", e);
        localStorage.removeItem("org");
        const pendingInvitationToken = localStorage.getItem(
          "pendingInvitationToken"
        );
        if (!pendingInvitationToken) {
          navigate("/listOrganization");
        }
      }
    } else {
      const pendingInvitationToken = localStorage.getItem(
        "pendingInvitationToken"
      );
      if (!pendingInvitationToken) {
        navigate("/listOrganization");
      }
    }
  };

  const createSession = async (refreshToken, user) => {
    try {
      const response = await axiosInstance.post(`/api/auth/open/session`, {
        refreshToken,
        userId: user._id,
        userType: "hr",
        email: user.email,
        username: user.username,
        firstName: user.firstName,
        lastName: user.lastName,
        avatarImage: user.profilePicture || user.avatarImage,
      });
      let data = response.data;
      if (data.success) {
        setCookie("accessToken", data.token);
        await getOrganizations();
        authorize(true, (setUser) => setUser(user));
      } else {
        authorize(true, (setUser) => setUser(user)); // Still authorize to show app, but may be broken
        navigate("/createOrganization");
        setTimeout(() => {
          signOut();
        }, 6000);
      }
    } catch (e) {
      authorize(true, (setUser) => setUser(user));
      navigate("/createOrganization");
      setTimeout(() => {
        signOut();
      }, 6000);
    }
  };

  useEffect(() => {
    (async () => {
      const queryParameters = new URLSearchParams(window.location.search);
      const pathName = window.location.pathname;

      if (pathName.startsWith("/accept-agent-invite")) {
        const agentInviteToken = queryParameters.get("token");
        if (agentInviteToken) {
          localStorage.setItem("pendingInvitationToken", agentInviteToken);
        } else {
        }
      } else if (pathName.startsWith("/organization/")) {
        const orgInvitePathParts = pathName.split("/");
        // Ensure there's something after '/organization/' and it's not an empty string or just 'organization'
        if (orgInvitePathParts.length > 2 && orgInvitePathParts[2]) {
          const orgInviteToken = orgInvitePathParts[2];
          localStorage.setItem("pendingInvitationToken", orgInviteToken);
        } else {
        }
      }

      try {
        const userId = queryParameters.get("userId");
        const refreshToken = queryParameters.get("refreshToken");

        if (userId) {
          var formData = new FormData();
          formData.append("id", userId);
          const response = await fetch(
            "https://api.accounts.clikkle.com/api/auth/get_user_profile",
            {
              method: "POST",
              body: formData,
            }
          );

          if (response.ok) {
            const responseData = await response.json();
            let { user } = responseData;
            user.refreshToken = refreshToken; // Attach refreshToken from query
            console.log(
              "[Authorize.js Main useEffect] User profile fetched from accounts:",
              user?.email
            );
            localStorage.setItem("user", JSON.stringify(user));
            await createSession(refreshToken, user);
          } else {
            // console.error("[Authorize.js Main useEffect] Failed to fetch user profile from accounts. Status:", response.status);
            authorize(false); // Cannot proceed without user profile
          }
        } else if (localStorage.getItem("user")) {
          let user = JSON.parse(localStorage.getItem("user"));
          // console.log("[Authorize.js Main useEffect] User found in localStorage:", user?.email);
          await createSession(user.refreshToken, user);
        } else {
          console.log(
            "[Authorize.js Main useEffect] No userId in query, no user in localStorage. Calling authorize(false)."
          );
          authorize(false);
        }
      } catch (err) {
        console.error(
          "[Authorize.js Main useEffect] CATCH block error during auth init:",
          err
        );
        authorize(false);
      }
    })();
  }, []);

  return (
    <authorizeContext.Provider
      value={{ authorize, setUser, user, setContent, currentOrganization }}
    >
      <SocketEmployeeProvider>
        <SocketProvider>{content}</SocketProvider>
      </SocketEmployeeProvider>
    </authorizeContext.Provider>
  );
};

const useAuthorize = () => useContext(authorizeContext).authorize;
const useUser = () => useContext(authorizeContext)?.user;
const useOrganization = () => {
  const contextValue = useContext(authorizeContext);
  if (contextValue) {
    return contextValue.currentOrganization;
  }
  return undefined;
};
const useSetUser = () => useContext(authorizeContext).setUser;
const useSetContent = () => useContext(authorizeContext).setContent;
const useEmployees = () => useContext(authorizeContext)?.employees;

export default AuthorizationProvider;
export {
  useAuthorize,
  useUser,
  useSetUser,
  useSetContent,
  useEmployees,
  useOrganization,
  authorizeContext,
};
